import { render } from "./DraggableDialogDemo.vue?vue&type=template&id=445ec3fb&scoped=true"
import script from "./DraggableDialogDemo.vue?vue&type=script&lang=ts"
export * from "./DraggableDialogDemo.vue?vue&type=script&lang=ts"

import "./DraggableDialogDemo.vue?vue&type=style&index=0&id=445ec3fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-445ec3fb"

export default script